import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=d5d86c90&scoped=true&"
import script from "./Role.vue?vue&type=script&lang=js&"
export * from "./Role.vue?vue&type=script&lang=js&"
import style0 from "./Role.vue?vue&type=style&index=0&id=d5d86c90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d86c90",
  null
  
)

export default component.exports